
  import { reactive } from "vue";
  import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";
  
  export default {
    name: "PasswordForAuthenticatedUser",
    inheritAttrs: false,
    components: {
      DynamicForm
    },
      setup() {    
      const request = reactive({
        apiLoadMethod: "api/Form/loadForm",
        apiSaveMethod: "api/Form/saveForm",
        form: "PasswortVergessen",
        page: "PasswortZuruecksetzen",
        remoteId: "",
        waitForResponse: true
      });  
      return {
        request,
      };
    }
  };
